import React, { Component } from 'react'
import PropTypes from 'prop-types'
import withReduxModal from '../../../modules/redux-modal/redux/withReduxModal'
import { compose } from 'recompose'
import ListingPortalSearch from './ListingPortalSearch'

class ListingPortalSearchModalRedux extends Component {
  static propTypes = {}

  render() {
    return (
      <div>
        <ListingPortalSearch />
      </div>
    )
  }
}

export default compose(withReduxModal)(ListingPortalSearchModalRedux)



// WEBPACK FOOTER //
// ./src/components/templates/listing-portal/ListingPortalSearchModalRedux.js